"use client";

import { useEffect, useState } from "react";

import { getBentoCells } from "../_utils/bento";

import { type BentoSkill, SkillCard } from "./skill-card";

// =============================================================================

type SkillsBentoProps = { skills: BentoSkill[] };

/**
 * Bento grid of the technologies: rows of 2, 4, 3 and 4 cards on large
 * screens, two columns on tablets, one on phones. One card is active at a
 * time.
 */
export function SkillsBento({ skills }: SkillsBentoProps) {
  const [activeSlug, setActiveSlug] = useState<string | null>(null);
  const cells = getBentoCells(skills.length);
  const hasOddCount = skills.length % 2 === 1;

  // Coming from a "/skills#nextjs" link: open the targeted card
  useEffect(() => {
    const slug = decodeURIComponent(window.location.hash.slice(1));
    if (!skills.some((skill) => skill.slug === slug)) return;
    const timer = window.setTimeout(() => setActiveSlug(slug), 700);
    return () => window.clearTimeout(timer);
  }, [skills]);

  return (
    <ul className="grid gap-[clamp(0.875rem,1.55vw,1.375rem)] sm:grid-cols-2 lg:grid-cols-12">
      {skills.map((skill, index) => (
        <SkillCard
          key={skill.id}
          skill={skill}
          cell={cells[index]}
          isWideOnTablet={hasOddCount && index === skills.length - 1}
          isActive={activeSlug === skill.slug}
          onActivate={() => setActiveSlug(skill.slug)}
          onDeactivate={() =>
            setActiveSlug((current) =>
              current === skill.slug ? null : current
            )
          }
          onToggle={() =>
            setActiveSlug((current) =>
              current === skill.slug ? null : skill.slug
            )
          }
        />
      ))}
    </ul>
  );
}

// =============================================================================
